
<div class="langauge-detail-container">
    <ng-container *ngIf="!dictionaryNotFound && dataLoaded">
        <div class="d-flex justify-content-center mt-4 mb-5">
            <span class="fs-4">
                {{'admin.languages.app.title' | translate}} <span class="text-primary fw-bold">{{language?.name}}</span>
            </span>
        </div>
        <div class="d-flex justify-content-center mb-4">
            <span class="col-9 text-center">
                <div *ngIf="entityType === TRANSLATION_MANAGER_TYPE.APP_FILES; else subtitleDictionaryTranslation">
                    <div *ngIf="originalDbTranslation === null && dataLoaded" class="d-flex justify-content-center align-items-center">
                        <i class="app-icon icon icon-warning-triangle-fill icon-xl2 overdue-icon"></i>
                        {{'admin.languages.app.dbTranslationFileNotFound' | translate}}
                    </div>
                    <span [innerHTML]="'admin.languages.app.subtitle1' | translate: { language: language?.name }"></span>
                    <div class="d-flex justify-content-center">
                        <div class="l-uploader-input">
                            <label class="attach-file-btn cursor-pointer" for="upload-document">{{'contractModifications.wizard.attachFileBtn' | translate}}</label>
                            <input type="file" #fileInput class="l-input-file" (change)="uploadTranslationFileHandler($event)" id="upload-document"/>
                        </div>
                        <div class="l-upload-section-content gap-3">
                            <div HJSuppress class="l-file-container px-2 d-flex align-items-center justify-content-between" *ngIf="uploadedFile">
                                <span class="l-file-name text-ellipsis">{{uploadedFile.name}}</span>
                                <span class="l-file-size">{{uploadedFile.size}} kb</span> 
                                <button type="button" class="btn delete-btn custom-delete-btn" 
                                    (click)="deleteFileHandler(fileInput)">
                                    <i class="app-icon icon icon-delete icon-md2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <span>{{'admin.languages.app.subtitle2' | translate}}</span>
                </div>
                <ng-template #subtitleDictionaryTranslation><span [innerHtml]="dictionaryTranslationSubtitle"></span></ng-template>
            </span>
        </div>
        <div class="d-flex justify-content-end mb-1">
            <button class="btn m-outline-btn l-uploader-input" (click)="exportToExcelHandler()">
               <i class="app-icon icon icon-file-excel icon-lg"></i>
               <span>{{ "admin.languages.app.exportTranslation" | translate }}</span>
           </button>
        </div>
        <form #form="ngForm">
            <div class="table-container mb-3">
                <table class="translation-table">
                    <thead>
                        <tr>
                            <th class="p-2">{{'admin.languages.translationKey' | translate}}</th>
                            <th class="p-2">{{'admin.languages.translationRefLanguage' | translate}}</th>
                            <th class="p-2"><span class="text-primary fw-bold">{{language?.name}}</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let prop of refTranslation | keyvalue" class="generic-row">
                            <td class="p-2 text-break">{{prop.key}}</td>
                            <td class="p-2 text-break">{{prop.value}}</td>
                            <td class="p-2 text-break">
                                <div class="text-area-container">
                                    <textarea 
                                        name="prop-{{prop.key}}"
                                        id='input-{{prop.key}}'
                                        type="text"
                                        placeholder="{{ 'admin.languages.app.enterValue' | translate }}"
                                        [(ngModel)]="targetTranslation[prop.key]" 
                                        required
                                        class="w-100"
                                        rows="3"
                                    ></textarea>
                                </div>
                                <span *ngIf="originalDbTranslation && targetTranslation[prop.key] !== originalDbTranslation[prop.key]"
                                    class="modified-translation"
                                    [ngbTooltip]="unsavedContent">
                                </span>
                                <ng-template #unsavedContent>
                                    {{'admin.languages.app.unsavedChanges' | translate}}
                                  </ng-template>
                                <div class="text-danger" *ngIf="validateInputTranslation(targetTranslation[prop.key])">
                                    {{'common.validation.required' | translate}}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </form>

        <div class="d-flex justify-content-center">
            <button class="btn primary-btn" (click)="saveBtnHandler()">
                {{'common.save' | translate}}
            </button>
        </div>
    </ng-container>

    <div *ngIf="dictionaryNotFound" class="d-flex flex-column justify-content-center align-items-center">
        <span class="fs-4 mb-2">{{'admin.languages.dictionary.dictionaryNotFound' | translate}}</span>
        <button class="btn primary-btn" (click)="selectDictionaryHandler()">
            {{'admin.languages.dictionary.redirectChooseDictionary' | translate}}
        </button>
    </div>
</div>
